import * as types from "../constants/actionTypes";

export const docsDataInitialState = {

};

export default function docsReducer(state = docsDataInitialState, action) {
    switch (action.type) {
        case types.LOAD_DOCS_DATA:
            return { ...state, docId: action.payload.docId, localization: action.payload.localization, error: false, isFetching: true };
        case types.LOAD_DOCS_DATA_SUCCESS:
            return { ...state, docsData: action.docsData, isFetching: false };
        case types.GET_PRIVACY_HEALTHPLAN_TEXT:
            return { ...state, healthPlanPrivacydata: { featureId: action.featureId, token: action.token, text: null, error: false, isFetching: true } };
        case types.GET_PRIVACY_HEALTHPLAN_TEXT_SUCCESS:
            return { ...state, healthPlanPrivacydata: { featureId: null, token: null, text: getTextToDisplay(action, 'healthPlanPrivacydata'), error: responseHasError(action, 'healthPlanPrivacydata'), isFetching: false } };
        case types.GET_PRIVACY_HEALTHPLAN_TEXT_FAILURE:
            return { ...state, healthPlanPrivacydata: { featureId: null, token: null, text: null, error: true, isFetching: false } };
        case types.GET_PRIVACY_MYBSWH_TEXT:
            return { ...state, bswhPrivacydata: { featureId: action.featureId, token: action.token, text: null, error: false, isFetching: true } };
        case types.GET_PRIVACY_MYBSWH_TEXT_SUCCESS:
            return { ...state, bswhPrivacydata: { featureId: null, token: null, text: getTextToDisplay(action, 'bswhPrivacydata'), error: responseHasError(action, 'bswhPrivacydata'), isFetching: false } };
        case types.GET_PRIVACY_MYBSWH_TEXT_FAILURE:
            return { ...state, bswhPrivacydata: { featureId: null, token: null, text: null, error: true, isFetching: false } };
        case types.GET_PRIVACY_MYCHART_TEXT:
            return { ...state, myChartPrivacyData: { featureId: action.featureId, token: action.token, text: null, error: false, isFetching: true } };
        case types.GET_PRIVACY_MYCHART_TEXT_SUCCESS:
            return { ...state, myChartPrivacyData: { featureId: null, token: null, text: getTextToDisplay(action, 'myChartPrivacyData'), error: responseHasError(action, 'myChartPrivacyData'), isFetching: false } };
        case types.GET_PRIVACY_MYCHART_TEXT_FAILURE:
            return { ...state, myChartPrivacyData: { featureId: null, token: null, text: null, error: true, isFetching: false } }
        case types.FAQ:
            return { ...state, faq: { waiting: true, list: null, error: null } };
        case types.FAQ_SUCCESS:
            return { ...state, faq: { waiting: false, list: action.faq, error: null } };
        case types.FAQ_FAILURE:
            return { ...state, faq: { waiting: false, list: null, error: action.error } };
        default:
            return { ...state };
    }
}

function getTextToDisplay(action, privacyType) {
    let textToDisplay = "";
    try {
        if (action && action[privacyType] && action[privacyType].message && JSON.parse(action[privacyType].message) && JSON.parse(action[privacyType].message)[0] && JSON.parse(action[privacyType].message)[0].textToDisplay) {
            textToDisplay = JSON.parse(action[privacyType].message)[0].textToDisplay;
        }
    }
    catch (Exception) { 
      //Json.Parse error
        console.log(Exception);
    }
    return textToDisplay;
}



function responseHasError(action, privacyType){
    let hasError = false;
    try {
    if (action && action[privacyType] && typeof action[privacyType] !== 'undefined') {
        hasError = action[privacyType].isSuccessful?false:true;
        }
    }    
    catch (Exception) { 
        console.log(Exception);
    }
    return hasError;
}